module.exports = "/_next/static/images/Frame-33e9f16f9f1cb7340f2af07f09365a2c.png";